/* global
  debounce 
*/
document.addEventListener('DOMContentLoaded', () => {
  // ==================== 工具函数 ====================
  // 用于 resize 和 search input 防抖处理

  // ==================== 手风琴功能 ====================
  const faqItems = Array.from(document.querySelectorAll('.wd-faq-item'))
  const DURATION = 300

  const accordion = {
    getParts: item => ({
      body: item.querySelector('.wd-faq-item-body'),
      inner: item.querySelector('.wd-faq-item-body-inner')
    }),

    open: item => {
      const { body, inner } = accordion.getParts(item)
      if (!body || !inner) return

      item.setAttribute('open', '')
      item.classList.add('wd-faq-item-active')
      body.style.maxHeight = '0px'
      requestAnimationFrame(() => (body.style.maxHeight = `${inner.scrollHeight}px`))
    },

    close: item => {
      const { body, inner } = accordion.getParts(item)
      if (!body || !inner) return

      body.style.maxHeight = `${inner.scrollHeight}px`
      requestAnimationFrame(() => (body.style.maxHeight = '0px'))
      item.classList.remove('wd-faq-item-active')
      setTimeout(() => item.removeAttribute('open'), DURATION)
    },

    closeAll: except => {
      faqItems.forEach(item => {
        if (item !== except && item.classList.contains('wd-faq-item-active')) {
          accordion.close(item)
        }
      })
    },

    init: () => {
      // 初始化高度
      faqItems.forEach(item => {
        const { body, inner } = accordion.getParts(item)
        if (!body || !inner) return
        body.style.maxHeight = item.classList.contains('wd-faq-item-active') ? `${inner.scrollHeight}px` : '0px'
      })

      // 点击事件
      faqItems.forEach(item => {
        item.querySelector('summary')?.addEventListener('click', e => {
          e.preventDefault()
          const isOpen = item.classList.contains('wd-faq-item-active')
          accordion.closeAll(item)
          isOpen ? accordion.close(item) : accordion.open(item)
        })
      })

      // 窗口调整（防抖处理）
      window.addEventListener(
        'resize',
        debounce(() => {
          faqItems.forEach(item => {
            if (item.classList.contains('wd-faq-item-active')) {
              const { body, inner } = accordion.getParts(item)
              if (body && inner) body.style.maxHeight = `${inner.scrollHeight}px`
            }
          })
        }, 150)
      )
    }
  }

  // ==================== 分类导航高亮 ====================
  const categoryItems = Array.from(document.querySelectorAll('.faq-category-list li'))
  const sections = Array.from(document.querySelectorAll('.faq-content-right > div[id]'))
  let isHashNavigating = false

  const navigation = {
    highlightCategory: sectionId => {
      const activeLi = categoryItems.find(li => li.dataset.sectionId === sectionId)

      categoryItems.forEach(li => {
        li.classList.toggle('active', li.dataset.sectionId === sectionId)
      })

      // 移动端横向滚动自动显示当前高亮项
      if (activeLi && window.innerWidth <= 1024) {
        const categoryList = document.querySelector('.faq-category-list')
        if (categoryList) {
          activeLi.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
        }
      }
    },
    //点击类目滚动到对应区域
    scrollToSection: (sectionId, block = 'start') => {
      const section = sections.find(s => s.id === sectionId)
      if (section) section.scrollIntoView({ behavior: 'smooth', block })
    },

    handleHashNavigation: () => {
      const targetId = window.location.hash.substring(1)
      if (!targetId) return

      const targetItem = document.getElementById(targetId)

      // 处理 item hash（问题详情）
      if (targetItem?.classList.contains('wd-faq-item')) {
        const parentSection = targetItem.closest('div[id]')
        isHashNavigating = true

        setTimeout(() => {
          accordion.open(targetItem)
          targetItem.scrollIntoView({ behavior: 'smooth', block: 'center' })
          if (parentSection) navigation.highlightCategory(parentSection.id)
          setTimeout(() => (isHashNavigating = false), 1000)
        }, 100)
      }
      // 处理 section hash（板块）
      else if (sections.find(s => s.id === targetId)) {
        isHashNavigating = true
        setTimeout(() => {
          navigation.scrollToSection(targetId)
          navigation.highlightCategory(targetId)
          setTimeout(() => (isHashNavigating = false), 1000)
        }, 100)
      }
    },

    init: () => {
      // 点击分类滚动
      categoryItems.forEach(li => {
        li.addEventListener('click', () => navigation.scrollToSection(li.dataset.sectionId))
        li.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            li.click()
          }
        })
      })

      // 监听滚动高亮
      const observer = new IntersectionObserver(
        entries => {
          if (isHashNavigating) return
          const visible = entries.filter(e => e.isIntersecting)
          if (visible.length) {
            const topEntry = visible.reduce((prev, curr) =>
              curr.boundingClientRect.top < prev.boundingClientRect.top ? curr : prev
            )
            navigation.highlightCategory(topEntry.target.id)
          }
        },
        { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
      )

      sections.forEach(section => observer.observe(section))
      navigation.handleHashNavigation()
    }
  }

  // ==================== 搜索功能 ====================
  const searchInput = document.getElementById('faq-search-input')
  const searchClear = document.getElementById('faq-search-clear')
  let searchTimeout = null
  // 预构建的数据结构，避免每次搜索都重新遍历/查 DOM。
  let searchCache = null

  const search = {
    //把可搜索内容预处理出来，缓存起来。(只搜索标题)
    buildCache: () => {
      searchCache = sections.map(section => {
        const items = Array.from(section.querySelectorAll('.wd-faq-item')).map(item => ({
          el: item,
          title: item.querySelector('.wd-faq-item-title'),
          text: item.querySelector('.wd-faq-item-title')?.textContent.toLowerCase() || ''
        }))

        const subsections = Array.from(section.querySelectorAll('.faq-content-right-subtitle')).map(subtitle => {
          const subItems = []
          let el = subtitle.nextElementSibling
          while (
            el &&
            !el.classList.contains('faq-content-right-subtitle') &&
            !el.classList.contains('faq-content-right-title')
          ) {
            if (el.classList.contains('wd-faq-item')) {
              const cached = items.find(item => item.el === el)
              if (cached) subItems.push(cached)
            }
            el = el.nextElementSibling
          }
          return { el: subtitle, items: subItems }
        })

        return {
          el: section,
          sectionTitle: section.querySelector('.faq-content-right-title'),
          items,
          subsections
        }
      })
    },
    // 执行过滤 + 更新计数 + no results
    filter: keyword => {
      const lowerKeyword = keyword.toLowerCase().trim()

      if (!lowerKeyword) {
        search.showAll()
        return
      }
      //统计可见数量
      let totalVisibleCount = 0

      searchCache.forEach((section, idx) => {
        let visibleCount = 0

        section.items.forEach(item => {
          //搜索
          const isMatch = item.text.includes(lowerKeyword)
          item.el.classList.toggle('hidden', !isMatch)
          if (isMatch) visibleCount++
        })

        // 子标题如果下面没有可见 item，也隐藏
        section.subsections.forEach(sub => {
          const hasVisible = sub.items.some(item => !item.el.classList.contains('hidden'))
          sub.el.classList.toggle('hidden', !hasVisible)
        })

        // section 本身如果没有可见 item，也隐藏
        const hasVisible = visibleCount > 0
        section.el.classList.toggle('hidden', !hasVisible)
        if (section.sectionTitle) section.sectionTitle.classList.toggle('hidden', !hasVisible)

        // 左侧类目计数更新
        const categoryLi = categoryItems[idx]
        const countSpan = categoryLi?.querySelector('.faq-category-count')
        if (categoryLi) {
          categoryLi.classList.toggle('hidden', !hasVisible)
          if (countSpan) {
            countSpan.textContent = hasVisible ? `(${visibleCount})` : ''
            countSpan.classList.toggle('show', hasVisible)
          }
        }

        totalVisibleCount += visibleCount
      })

      const categoryList = document.querySelector('.faq-category-list')
      const contentRight = document.querySelector('.faq-content-right')
      const noResults = document.querySelector('.faq-no-results')

      if (totalVisibleCount === 0) {
        if (categoryList) categoryList.classList.add('hidden')
        if (contentRight) contentRight.classList.add('hidden')
        if (noResults) noResults.classList.add('show')
      } else {
        if (categoryList) categoryList.classList.remove('hidden')
        if (contentRight) contentRight.classList.remove('hidden')
        if (noResults) noResults.classList.remove('show')
      }
    },

    showAll: () => {
      const allElements = document.querySelectorAll('.hidden')
      allElements.forEach(el => el.classList.remove('hidden'))

      document.querySelectorAll('.faq-category-count').forEach(span => {
        span.textContent = ''
        span.classList.remove('show')
      })

      const noResults = document.querySelector('.faq-no-results')
      if (noResults) noResults.classList.remove('show')
    },
    //清空输入框 + 隐藏清除按钮 + 展示全部内容
    clear: () => {
      searchInput.value = ''
      searchClear.classList.remove('show')
      search.showAll()
    },

    init: () => {
      if (!searchInput || !searchClear) return

      search.buildCache()

      searchInput.addEventListener('input', e => {
        const { value } = e.target
        searchClear.classList.toggle('show', value.length > 0)

        clearTimeout(searchTimeout)
        searchTimeout = setTimeout(() => search.filter(value), 500)
      })

      searchClear.addEventListener('click', () => search.clear())
    }
  }

  // 初始化
  if (faqItems.length) accordion.init()
  if (categoryItems.length && sections.length) navigation.init()
  search.init()
})
